import { Rule } from "antd/es/form";
import { regexpInnIndividual, regexpSnils } from "../RegexpConstants";

export const ruleMaxAccount: Rule = {
  len: 20,
  message: "Счёт должен иметь длину 20 символов",
};

export const ruleInnIndividual: Rule = {
  pattern: regexpInnIndividual,
  message: "Введите существующий ИНН",
};

export const ruleSnils: Rule = {
  pattern: regexpSnils,
  message: "Снилс должен иметь длину 11 символов",
};
